import Endpoint from "@/utils/endPoint";

const assessmentListEndpoint = new Endpoint("/student_assessments/teachers/assessments");
const assessmentEndpoint = new Endpoint("/student_assessments/teachers/assessments/{assessmentId}");


const templateListEndpoint = new Endpoint("/student_assessments/templates/");
const templateEndpoint = new Endpoint("/student_assessments/templates/{templateId}");


const taskListEndpoint = new Endpoint("/student_assessments/tasks");
const taskEndpoint = new Endpoint("/student_assessments/tasks/{taskId}");
const archiveTaskEndpoint = new Endpoint("/student_assessments/tasks/{taskId}/archive");
const unarchiveTaskEndpoint = new Endpoint("/student_assessments/tasks/{taskId}/unarchive");
const klassTaskListEndpoint = new Endpoint("/student_assessments/klass_tasks");

const assessmentStatusEndpoint = new Endpoint("/student_assessments/teachers/assessments/{assessmentId}/status/{status}");


class AssessmentService {
    async createAssessmentService(params) {
        const result = await assessmentListEndpoint.post(params);
        return result;
    }
    async delAssessmentService(params) {
        const result = await assessmentEndpoint.del(null, params);
        return result;
    }
    async updateAssessmentService(params) {
        const { assessmentId, ...param } = params;
        const result = await assessmentEndpoint.put(param, { assessmentId });
        return result;
    }
    async getAssessmentService(params) {
        const result = await assessmentEndpoint.get(params);
        return result;
    }
    async getAssessmentListService(params) {
        const result = await assessmentListEndpoint.get(params);
        return result;
    }

    
    async updateAssessmentStatusService(params) {
        const result = await assessmentStatusEndpoint.put(null, params);
        return result;
    }

    
    async getTemplateListService(params) {
        const result = await templateListEndpoint.get(params);
        return result;
    }
    async getTemplateService(params) {
        const result = await templateEndpoint.get(params);
        return result;
    }

    
    async createTaskService(params) {
        const result = await taskListEndpoint.post(params);
        return result;
    }

    async delTaskService(params) {
        const result = await taskEndpoint.del(null, params);
        return result;
    }

    async updateTaskService(params) {
        const { taskId, ...param } = params;
        const result = await taskEndpoint.put(param, { taskId });
        return result;
    }

    async updateTaskStatusService(params) {
        const { taskId, isActive } = params;
        let result = null;
        if (isActive) {
            result = await archiveTaskEndpoint.put(null, { taskId });
        } else {
            result = await unarchiveTaskEndpoint.put(null, { taskId });
        }
        return result;
    }

    async getTaskService(params) {
        const result = await taskEndpoint.get(params);
        return result;
    }

    async getTaskListService(params) {
        const result = await taskListEndpoint.get(params);
        return result;
    }

    async getKlassTaskListService(params) {
        const result = await klassTaskListEndpoint.get(params);
        return result;
    }
}

export default new AssessmentService();
